import { useState, useEffect } from 'react';
import { FiMessageCircle, FiArrowUp } from 'react-icons/fi';
import { motion, AnimatePresence } from 'framer-motion';

const FloatingButtons = () => {
  const [showScrollTop, setShowScrollTop] = useState(false);
  const [isHovered, setIsHovered] = useState({ whatsapp: false, scroll: false });
  const [isCartOpen, setIsCartOpen] = useState(false);

  // Handle scroll event
  useEffect(() => {
    const handleScroll = () => {
      setShowScrollTop(window.scrollY > 400);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  // Listen for cart open/close events
  useEffect(() => {
    const handleCartOpen = () => setIsCartOpen(true);
    const handleCartClose = () => setIsCartOpen(false);

    window.addEventListener('openCart', handleCartOpen);
    window.addEventListener('closeCart', handleCartClose);
    
    return () => {
      window.removeEventListener('openCart', handleCartOpen);
      window.removeEventListener('closeCart', handleCartClose);
    };
  }, []);

  // Smooth scroll to top
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };

  // WhatsApp click handler
  const handleWhatsAppClick = () => {
    const phoneNumber = "916238249819"; // Include country code without +
    const message = encodeURIComponent(
      "Hi Panchali Design Hub,\n\nI'm interested in your collections and would like to know more details.\n\nThank you!"
    );
    window.open(`https://wa.me/${phoneNumber}?text=${message}`, '_blank');
  };

  return (
    <AnimatePresence>
      {!isCartOpen && (
        <motion.div 
          initial={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          className="fixed bottom-6 right-6 z-50 flex flex-col gap-4"
        >
          {/* WhatsApp Button */}
          <div
            className="relative cursor-pointer"
            onClick={handleWhatsAppClick}
            onMouseEnter={() => setIsHovered({ ...isHovered, whatsapp: true })}
            onMouseLeave={() => setIsHovered({ ...isHovered, whatsapp: false })}
          >
            <div className="absolute inset-0">
              <div className="absolute inset-0 rounded-full bg-green-500 animate-ping opacity-25"></div>
              <div className="absolute inset-0 rounded-full bg-green-500 animate-ping opacity-25" style={{ animationDelay: '0.5s' }}></div>
            </div>

            <div className="relative flex items-center justify-center w-14 h-14 bg-green-500 rounded-full shadow-lg hover:bg-green-600 transition-colors focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-500">
              <FiMessageCircle className="w-6 h-6 text-white" />
            </div>
            
            {/* Tooltip */}
            <AnimatePresence>
              {isHovered.whatsapp && (
                <motion.div
                  initial={{ opacity: 0, x: -10 }}
                  animate={{ opacity: 1, x: 0 }}
                  exit={{ opacity: 0, x: -10 }}
                  className="absolute right-full mr-4 top-1/2 -translate-y-1/2 bg-black/75 text-white px-3 py-1.5 rounded-lg text-sm whitespace-nowrap"
                >
                  Chat with us on WhatsApp
                  <div className="absolute right-0 top-1/2 -translate-y-1/2 translate-x-1/2 transform rotate-45 w-2 h-2 bg-black/75"></div>
                </motion.div>
              )}
            </AnimatePresence>
          </div>

          {/* Scroll to Top Button */}
          <AnimatePresence>
            {showScrollTop && (
              <div
                className="relative"
                onMouseEnter={() => setIsHovered({ ...isHovered, scroll: true })}
                onMouseLeave={() => setIsHovered({ ...isHovered, scroll: false })}
              >
                <button
                  onClick={scrollToTop}
                  className="flex items-center justify-center w-14 h-14 bg-[#2C3E50] rounded-full shadow-lg hover:bg-[#34495E] transition-colors focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-[#2C3E50]"
                >
                  <FiArrowUp className="w-6 h-6 text-white" />
                </button>

                {/* Tooltip */}
                <AnimatePresence>
                  {isHovered.scroll && (
                    <motion.div
                      initial={{ opacity: 0, x: -10 }}
                      animate={{ opacity: 1, x: 0 }}
                      exit={{ opacity: 0, x: -10 }}
                      className="absolute right-full mr-4 top-1/2 -translate-y-1/2 bg-black/75 text-white px-3 py-1.5 rounded-lg text-sm whitespace-nowrap"
                    >
                      Scroll to top
                      <div className="absolute right-0 top-1/2 -translate-y-1/2 translate-x-1/2 transform rotate-45 w-2 h-2 bg-black/75"></div>
                    </motion.div>
                  )}
                </AnimatePresence>
              </div>
            )}
          </AnimatePresence>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default FloatingButtons;













